import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import {BrowserRouter} from "react-router-dom";
// import reportWebVitals from './reportWebVitals';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/global.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
            <ToastContainer
                position="top-right"
                closeButton={false}
                closeOnClick
                rtl
                draggable
                pauseOnHover={false}
                autoClose={3000}/>
        </BrowserRouter>
    </React.StrictMode>
)

// reportWebVitals();
